export const vendorManagementConstants = {
  zero: "0",
  one: "1",
  two: "2",
  three: "3",
  four: "4",
  countryId: "countryId",
  stateProvinceId: "stateProvinceId"
};
